import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/financial-management/income`;

export const incomeRoutesObj = {
  list: baseRoute,
} as const;

export type IIncomeRouteParams = IExtractRouteParamMap<typeof incomeRoutesObj>;

export const incomePath = createPaths<
  typeof incomeRoutesObj,
  IIncomeRouteParams
>(incomeRoutesObj);
